import moment from 'moment';

function fieldTypeToName(fieldType) {
  if (_.isString(fieldType)) {
    return _.capitalize(fieldType);
  } else if (_.isObject(fieldType)) {
    switch (fieldType.dataType) {
      case 'array':
        return 'Array(' + fieldTypeToName(fieldType.elementType) + ')';
      default:
        return _.capitalize(fieldType.dataType);
    }
  } else {
    return undefined;
  }
}

angular.module('magpieStructure', [
  'ui.bootstrap',
  'magpieProfiling',
  'magpieLineage',
  'magpieInference',
  'magpieUtil'
]).
directive('magpieTable', function() {
  return {
    restrict: 'E',
    scope: {
      lineage: '@?',
      table: '=?',
      profile: '@?',
      relationships: '@?',
      description: '@?',
      userPermissions: '=?'
    },
    templateUrl: 'components/magpie-display/structure/table.html',
    controller: function($scope) {
      if ($scope.description) {
        const description = JSON.parse($scope.description);

        $scope.hasLineage = description.lineage && description.lineage.createAction;
        if ($scope.hasLineage) {
          $scope.hasLineageGraph = $scope.hasLineage && description.lineage.lineageGraph;
          if ($scope.hasLineageGraph) {
            $scope.lineageGraph = JSON.stringify(description.lineage.lineageGraph);
            delete description.lineage.lineageGraph;
          }
        }
        $scope.lineage = description.lineage;
        $scope.table = description.table;
        $scope.relationships = JSON.stringify(description.relationships);
        $scope.profile = JSON.stringify(description.profile);
        $scope.userPermissions = description.userPermissions;
      }
      $scope.hasRelationships = $scope.relationships && (
        (
          // we are not an array--parse as JSON then check length
          _.isString($scope.relationships) &&
          JSON.parse($scope.relationships).length > 0
        ) || (
          // we are an array--check length directly
          _.isArray($scope.relationships) &&
          $scope.relationships.length > 0
        )
      );
    }
  };
}).
directive('magpieTableLineageGraph', function($timeout) {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/structure/table-lineage-graph.html',
    compile: function() {
      return function linkFunction($scope, element) {
        const maxEdges = 100;
        const DataSet = vis.DataSet; // eslint-disable-line no-undef
        const Network = vis.Network; // eslint-disable-line no-undef

        $scope.fitted = false;
        $scope.stabilized = false;
        $scope.currentNode = {};
        $scope.queryFlavors = {
          CLI: 'CLI',
          Zeppelin: 'notebook',
          ThriftServer: 'JDBC session'
        };

        const lineageGraph = JSON.parse($scope.lineageGraph);

        let smooth;
        let fixed;
        if (lineageGraph.edges.length >= maxEdges) {
          // too many edges, don't smooth and fix the nodes
          smooth = false;
          fixed = true;
        } else {
          // manageable number of edges, smooth and don't fix the nodes
          smooth = {
            type: 'cubicBezier',
            forceDirection: 'horizontal',
            roundness: 0.4
          };
          fixed = false;
        }

        const nodes = lineageGraph.nodes.map( (obj) => {
          let label = obj.name;

          if (obj.parentObjectName) {
            label = obj.parentObjectName + '.' + label;
          }

          // collapsed operations show their execution count on the node itself
          if (obj.nodeType === 'Operation' && obj.actionCount > 1) {
            label = label + ' ×' + obj.actionCount;
          }

          const node = {
            id: obj.id,
            label: label,
            name: obj.name,
            nodeType: obj.nodeType,
            createAction: obj.createAction,
            action: obj.action,
            operationType: obj.operationType,
            actionCount: obj.actionCount,
            firstStartTime: obj.firstStartTime,
            origin: obj.origin,
            lastWriteAction: obj.lastWriteAction,
            objectSubType: obj.objectSubType,
            parentObjectName: obj.parentObjectName,
            url: obj.url
          };

          if (fixed) {
            node.fixed = {
              x: true,
              y: true
            };
          }

          if (obj.objectType) {
            node.nodeType = obj.objectType;
          }

          if (obj.lineage && obj.lineage.createAction) {
            node.createAction = obj.lineage.createAction;
          }

          if (obj.objectSubType) {
            node.group = obj.objectSubType;
          } else if (obj.objectType) {
            node.group = obj.objectType;
          } else {
            node.group = obj.nodeType;
          }

          return node;
        });

        const nodesById = _.indexBy(nodes, 'id');

        const edges = new DataSet(lineageGraph.edges);

        // create a network
        const container = element.find('.network')[0];

        const data = {
          nodes: new DataSet(nodes),
          edges: edges
        };

        const options = {
          edges: {
            smooth: smooth,
            arrows: {
              to: true
            },
            color: {
              color: '#888',
              opacity: 1.0
            },
            arrowStrikethrough: false
          },
          nodes: {
            shape: 'box'
          },
          interaction: {
            dragNodes: true,
            dragView: true,
            hideEdgesOnDrag: false,
            hideNodesOnDrag: false,
            hover: false,
            keyboard: {
              enabled: true,
              bindToWindow: false
            },
            multiselect: false,
            navigationButtons: true,
            selectable: true,
            selectConnectedEdges: false,
            hoverConnectedEdges: false,
            zoomView: false
          },
          layout: {
            hierarchical: {
              enabled: true,
              sortMethod: 'directed',
              levelSeparation: 230,
              direction: 'LR'
            }
          },
          physics: true,
          autoResize: true,
          height: '450px',
          width: '100%',
          groups: {
            useDefaultGroups: true,
            Table: {
              shape: 'image',
              image: '/assets/images/structure/table.svg',
              background: 'white'
            },
            Stream: {
              shape: 'image',
              image: '/assets/images/structure/stream.svg'
            },
            Url: {
              shape: 'image',
              image: '/assets/images/structure/globe.svg'
            },
            Result: {
              shape: 'image',
              image: '/assets/images/structure/code.svg'
            },
            Operation: {
              shape: 'image',
              image: '/assets/images/structure/operation.svg'
            },
            DataSource: {
              shape: 'image',
              image: '/assets/images/structure/generic_source.svg'
            },
            kafka: {
              shape: 'image',
              image: '/assets/images/structure/kafka.svg'
            },
            hdfs: {
              shape: 'image',
              image: '/assets/images/structure/file_system.svg',
              background: 'white'
            },
            local: {
              shape: 'image',
              image: '/assets/images/structure/file_system.svg',
              background: 'white'
            },
            jdbc: {
              shape: 'image',
              image: '/assets/images/structure/database.svg'
            },
            postgres: {
              shape: 'image',
              image: '/assets/images/structure/database.svg'
            },
            snowflake: {
              shape: 'image',
              image: '/assets/images/structure/big_data_db.svg'
            },
            bigquery: {
              shape: 'image',
              image: '/assets/images/structure/big_data_db.svg'
            },
            redshift: {
              shape: 'image',
              image: '/assets/images/structure/big_data_db.svg',
              background: 'white'
            }
          }
        };

        $timeout(function() {
          const network = new Network(container, data, options);

          network.on('click', function(args) {
            $timeout(function() {
              const id = args.nodes[0];
              $scope.currentNode = nodesById[id];
            });
          });

          network.on('stabilizationIterationsDone', function() {
            $timeout(function() {
              $scope.network = network;
              $scope.stabilized = true;
              // if we haven't fixed the nodes, turn off physics
              if (!fixed) {
                network.setOptions({
                  physics: false
                });
              }
            });
          });

          network.on('afterDrawing', function() {
            if (!$scope.fitted) {
              network.fit();
              $scope.fitted = true;
            }
          });
        });
      };
    }
  };
}).
directive('magpieTableDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/structure/table-details.html',
    controller: function($scope) {
      $scope.getDatabaseExpressionLabel = function(expr) {
        if (_.isString(expr.tableName)) {
          return 'Table Name:';
        } else {
          return 'Query:';
        }
      };

      $scope.getDatabaseExpressionValue = function(expr) {
        if (_.isString(expr.schemaName)) {
          return expr.schemaName + '.' + expr.tableName;
        } else if (_.isString(expr.tableName)) {
          return expr.tableName;
        } else {
          return expr.query;
        }
      };

      $scope.getBigQueryExpressionLabel = function(expr) {
        if (_.isString(expr.tableId)) {
          return 'Table:';
        } else {
          return 'Query:';
        }
      };

      $scope.getBigQueryExpressionValue = function(expr) {
        if (_.isString(expr.tableId)) {
          return expr.datasetId + '.' + expr.tableId;
        } else {
          return expr.query;
        }
      };

      $scope.formatOffsets = function(offsets) {
        if (_.isString(offsets)) {
          return _.capitalize(offsets);
        } else {
          return JSON.stringify(offsets);
        }
      };

      $scope.getSubscriptionLabel = function(subscriptionType) {
        if (subscriptionType === 'TopicPartition') {
          return 'Partitions';
        } else {
          return subscriptionType;
        }
      };

      $scope.getSubscriptionValue = function(subscription) {
        switch (subscription.subscriptionType) {
          case 'Topic':
            return subscription.topic;
          case 'Topics':
            return subscription.topics.join(', ');
          case 'Pattern':
            return subscription.pattern;
          case 'TopicPartition':
            return JSON.stringify(subscription.partitions);
        }
      };
    }
  };
}).
directive('magpieTableState', function() {
  return {
    restrict: 'E',
    scope: {
      name: '@',
      state: '='
    },
    templateUrl: 'components/magpie-display/structure/table-state.html'
  };
}).
directive('magpieTableStateDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/structure/table-state-details.html'
  };
}).
directive('magpieStream', function() {
  return {
    restrict: 'E',
    scope: {
      lineage: '=?',
      stream: '=?',
      state: '=?',
      sinks: '=?',
      description: '=?',
      userPermissions: '=?'
    },
    templateUrl: 'components/magpie-display/structure/stream.html',
    controller: function($scope) {
      if ($scope.description) {
        $scope.stream = $scope.description.stream;
        $scope.state = $scope.description.state;
        $scope.lineage = $scope.description.lineage;
        $scope.sinks = $scope.description.sinks;
        $scope.history = $scope.description.history;
        $scope.userPermissions = $scope.description.userPermissions;
      }
    }
  };
}).
directive('magpieStreamDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/structure/stream-details.html'
  };
}).
directive('magpieStreamState', function() {
  return {
    restrict: 'E',
    scope: {
      name: '@',
      state: '='
    },
    templateUrl: 'components/magpie-display/structure/stream-state.html'
  };
}).
directive('magpieStreamStateDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/structure/stream-state-details.html',
    controller: function($scope) {
      $scope.getState = function(state) {
        if (state.activeSinks.length > 0) {
          return 'In Use';
        } else {
          return 'Not In Use';
        }
      };

      $scope.isResolved = function(sink) {
        return _.isUndefined(sink.userName);
      };
    }
  };
}).
directive('magpieField', function() {
  return {
    restrict: 'E',
    scope: {
      field: '=?',
      description: '=?'
    },
    templateUrl: 'components/magpie-display/structure/field.html',
    controller: function($scope) {
      if ($scope.description) {
        $scope.field = $scope.description.field;
      }
      $scope.fieldTypeToName = fieldTypeToName;
    }
  };
}).
directive('magpieFields', function() {
  return {
    restrict: 'E',
    scope: {
      fields: '='
    },
    templateUrl: 'components/magpie-display/structure/fields.html',
    controller: function($scope) {
      _.forEach($scope.fields, (field) => {
        field.fieldTypeName = fieldTypeToName(field.fieldType);
      });
    }
  };
}).
directive('magpieFile', function() {
  return {
    restrict: 'E',
    scope: {
      file: '=?',
      description: '@?'
    },
    templateUrl: 'components/magpie-display/structure/file.html',
    controller: function($scope) {
      // Helper function to format file size
      $scope.formatFileSize = function(bytes) {
        if (bytes === 0 || bytes === undefined) {
          return '0 Bytes';
        }
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
      };

      // Handle description attribute (for describe command)
      if ($scope.description) {
        const description = JSON.parse($scope.description);
        $scope.file = description;
        $scope.isFileMetadata = true;
      } else {
        $scope.isFileMetadata = false;
      }

      // Set flags for file format configuration (backward compatibility)
      if ($scope.file) {
        $scope.isDelimited = $scope.file.format === 'DelimitedText';
        $scope.isJson = $scope.file.format === 'JSON';
        $scope.hasCompression = !_.isUndefined($scope.file.compression);
        $scope.displaySpecialChar = (value) => JSON.stringify(value).slice(1, -1);

        // Format file size for display
        if ($scope.file.sizeBytes !== undefined) {
          $scope.formattedSize = $scope.formatFileSize($scope.file.sizeBytes);
        }
      }
    }
  };
}).
directive('magpieFieldMapping', function() {
  return {
    restrict: 'E',
    scope: {
      mapping: '='
    },
    templateUrl: 'components/magpie-display/structure/field-mapping.html',
    controller: function($scope) {
      $scope.isDirectMap = _.every($scope.mapping, (m) => m.sourceField === m.targetField);
    }
  };
}).
directive('magpieSink', function() {
  return {
    restrict: 'E',
    scope: {
      sink: '=?',
      state: '=?',
      description: '=?'
    },
    templateUrl: 'components/magpie-display/structure/sink.html',
    controller: function($scope) {
      if ($scope.description) {
        $scope.sink = $scope.description.sink;
        $scope.state = $scope.description.state;
        $scope.history = $scope.description.history;
      }
    }
  };
}).
directive('magpieSinkDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/structure/sink-details.html'
  };
}).
directive('magpieSinkState', function() {
  return {
    restrict: 'E',
    scope: {
      name: '@',
      state: '='
    },
    templateUrl: 'components/magpie-display/structure/sink-state.html'
  };
}).
directive('magpieSinkStateDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/structure/sink-state-details.html'
  };
}).
directive('magpieSinkHistory', function() {
  return {
    restrict: 'E',
    scope: {
      label: '@',
      sinkHistory: '=',
      timestamp: '@?'
    },
    templateUrl: 'components/magpie-display/structure/sink-history.html'
  };
}).
directive('magpieSinkHistoryDetails', function() {
  return {
    restrict: 'E',
    scope: {
      sinkHistory: '='
    },
    templateUrl: 'components/magpie-display/structure/sink-history-details.html'
  };
}).
directive('magpieSinkRun', function() {
  return {
    restrict: 'AE',
    scope: {
      sinkRun: '=',
      timestamp: '='
    },
    templateUrl: 'components/magpie-display/structure/sink-run.html',
    controller: function($scope, $element, $timeout, $controller) {
      angular.extend(this, $controller('MagpieExpandableRowCtrl', {
        $scope: $scope,
        $element: $element,
        $timeout: $timeout
      }));

      _.defaults($scope.sinkRun, {
        timestamp: moment($scope.timestamp)
      });
    }
  };
}).
directive('magpieSchema', function() {
  return {
    restrict: 'E',
    scope: {
      schema: '=?',
      lineage: '=?',
      profile: '@?',
      description: '@?',
      userPermissions: '=?'
    },
    templateUrl: 'components/magpie-display/structure/schema.html',
    controller: function($scope) {
      if ($scope.description) {
        const description = JSON.parse($scope.description);
        $scope.schema = description.schema;
        $scope.lineage = description.lineage;
        $scope.tables = description.tables;
        $scope.streams = description.streams;
        $scope.profile = JSON.stringify(description.profile);
        $scope.history = description.history;
        $scope.userPermissions = description.userPermissions;
      } else if ($scope.schema) {
        $scope.tables = $scope.schema.tables;
      }
    }
  };
}).
directive('magpieHdfsCredentials', function() {
  return {
    restrict: 'E',
    scope: {
      credentials: '='
    },
    templateUrl: 'components/magpie-display/structure/hdfs-credentials.html'
  };
}).
directive('magpieDataSource', function() {
  return {
    restrict: 'E',
    scope: {
      dataSource: '=?',
      lineage: '=?',
      description: '=?',
      userPermissions: '=?'
    },
    templateUrl: 'components/magpie-display/structure/data-source.html',
    controller: function($scope) {
      if ($scope.description) {
        $scope.dataSource = $scope.description.source;
        $scope.lineage = $scope.description.lineage;
        $scope.userPermissions = $scope.description.userPermissions;
      }
    }
  };
}).
directive('magpieRepository', function() {
  return {
    restrict: 'E',
    scope: {
      repository: '=?',
      lineage: '=?',
      description: '=?',
      userPermissions: '=?'
    },
    templateUrl: 'components/magpie-display/structure/repository.html',
    controller: function($scope) {
      const findName = (objects, id) => {
        if (id) {
          return _.result(_.find(objects, 'id', id), 'name');
        }
      };

      if ($scope.description) {
        $scope.repository = $scope.description.repository;
        $scope.dataSources = $scope.description.dataSources;
        $scope.defaultDataSourceName = findName($scope.dataSources, $scope.repository.defaultDataSourceId);
        $scope.projects = $scope.description.projects;
        $scope.defaultProjectName = findName($scope.projects, $scope.repository.defaultProjectId);
        $scope.schemas = $scope.description.schemas;
        $scope.defaultSchemaName = findName($scope.schemas, $scope.repository.defaultSchemaId);
        $scope.lineage = $scope.description.lineage;
        $scope.userPermissions = $scope.description.userPermissions;
      } else if ($scope.repository) {
        $scope.dataSources = $scope.repository.dataSources;
        $scope.defaultDataSourceName = $scope.repository.defaultDataSourceName;
        $scope.projects = $scope.repository.projects;
        $scope.defaultProjectName = $scope.repository.defaultProjectName;
        $scope.schemas = $scope.repository.schemas;
        $scope.defaultSchemaName = $scope.repository.defaultSchemaName;
      }
    }
  };
}).
directive('magpieObjectUserPermissions', function() {
  return {
    restrict: 'E',
    scope: {
      userPermissions: '='
    },
    templateUrl: 'components/magpie-display/structure/object-user-permissions.html'
  };
});



// WEBPACK FOOTER //
// ./src/components/magpie-display/structure/magpie-structure.js